{
  "name": "@monster-js/cli",
  "version": "1.5.32",
  "main": "dist/index.js",
  "description": "Command line interface for MonsterJS framework.",
  "engines": {
    "node": "^14.15.0 || >=16.10.0"
  },
  "license": "MIT",
  "type": "module",
  "scripts": {
    "build": "parcel build ./src/index.js",
    "watch": "parcel watch ./src/index.js"
  },
  "bin": {
    "mn": "./dist/index.js"
  },
  "author": "Darius Bualan Jr.",
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "mn",
    "monsterjs",
    "cli"
  ],
  "homepage": "https://monster-js.org",
  "repository": {
    "type": "git",
    "url": "https://github.com/monster-js/monster-js"
  },
  "funding": [
    {
      "type": "patreon",
      "url": "https://www.patreon.com/monsterjs"
    },
    {
      "type": "github",
      "url": "https://github.com/sponsors/monster-js"
    },
    {
      "type": "individual",
      "url": "https://www.paypal.com/paypalme/dariusbualan"
    }
  ],
  "dependencies": {
    "chalk": "^5.2.0",
    "commander": "^10.0.1",
    "execa": "^7.1.1",
    "inquirer": "^9.2.7",
    "listr": "^0.14.3",
    "open": "^9.1.0"
  }
}
